import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getData, postData } from "../../../../backend/api";

// Styled Components
const Container = styled.div`
  // max-width: 600px;
  width: 100%;
  margin: 0 20px;
  padding: 20px;
  font-size: 16px;
  background-color: #F0F5FF;
`;

const CommentBox = styled.div`
  border: 1px solid #ccc;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  background-color: #f9f9f9;
  display: inline-block;
  max-width: 80%; // Adjust this value as needed
`;

const CommentHeader = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
`;

const CommentText = styled.p`
  margin: 0;
  color: #555;
  word-wrap: break-word;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const TextArea = styled.textarea`
  width: calc(100% - 20px);
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  font-size: 18px;
  font-family: "Calibri",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Calibri",-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;

  &:hover {
    background-color: #0056b3;
  }
`;

const Status = styled.div`
  font-weight: bold;
  margin-bottom: 20px;
  color: ${(props) => (props.status === "Resolved" ? "green" : "red")};
`;

// Main Component
const WhistleblowingComments = ({ isAdmin=false, t, data , setMessage}) => {
  const [comments, setComments] = useState(data.comments || []);
  const [newComment, setNewComment] = useState("");
  const [status, setStatus] = useState(data?.status || "open");

  const getComments = async (data)=>{
    try {
      let payloadData = { whistleblowingId: data._id};
      await getData(payloadData, "whistleblowing-comment")
        .then((response) => {
          if (response.status === 200) {
            setComments(response.data.data)
            // udpateView(0);
          } else if (response.status === 404) {
            // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
          } else {
            // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
          }
          // setLoaderBox(false);
        })
        .catch((error) => {
          // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
          // setLoaderBox(false);
        });
    } catch (error) {
      
    }
  }

  useEffect(() => {
    getComments(data)
  }, [])
  

  const handleAddComment = async() => {
    if (newComment.trim()) {
        
        // setCurrentData(current);
        let payload = {
          comment: newComment,
          whistleblowingId: data._id
        }
        
        await postData(payload, `whistleblowing-comment`)
          .then((response) => {
            if (response.status === 200) {
              let res = {...response.data.data}
              res.user = null;
              setComments([...comments,res])
              setNewComment("");
              // udpateView(0);
            } else if (response.status === 404) {
              setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
            } else {
              setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
            }
            // setLoaderBox(false);
          })
          .catch((error) => {
            // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
            // setLoaderBox(false);
          });
        }
    }

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
  };
console.log(comments);
  return (
    <Container>
      {/* <h1>Whistleblowing Comments</h1> */}
      {/* <Status status={status}>{t("status")}: {t(status)}</Status> */}

      {isAdmin && (
        <div>
          <Button onClick={() => handleStatusChange("In Progress")}>
            Mark as In Progress
          </Button>
          <Button onClick={() => handleStatusChange("Resolved")}>
            Mark as Resolved
          </Button>
        </div>
      )}

      <div>
        {comments.map((item,index) => (
            <div key={index} style={{display:'flex', justifyContent: item?.user?._id ? 'flex-start' : 'flex-end' }}>
          <CommentBox>
            <CommentHeader>
              {item?.user?.fullName ? item?.user?.fullName : t("You")} - {item.createdAt ? new Date(item.createdAt).toLocaleString("de-DE", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      }) : ""}
            </CommentHeader>
            <CommentText>{item.comment}</CommentText>
          </CommentBox>
          </div>
        ))}
      </div>

      <div>
        <TextArea
          rows="4"
          placeholder={t("addAComment")}
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <Button style={{fontSize:"18px"}} onClick={handleAddComment}>{t("Add Comment")}</Button>
      </div>
    </Container>
  );
};

export default WhistleblowingComments;